import Axios from '@/plugins/Axios';

import {
  DataPaymentToken,
  OrderPaymentStatus,
  PayloadGetPaymentToken,
} from '@/types';
import { AxiosResponse } from 'axios';

const endpoint = '/payment';

const paymentApi = {
  getListPayment: (data: PayloadGetPaymentToken) => {
    return Axios().post<DataPaymentToken>(`${endpoint}`, data);
  },

  getOrderPaymentStatus: (id: string | number) => {
    return Axios().get<OrderPaymentStatus>(`${endpoint}/${id}`);
  },

  changePaymentMethod: (id: string | number) => {
    return Axios().put<DataPaymentToken>(`${endpoint}/${id}`);
  },
};

export default paymentApi;
